import type { ReactNode } from "react";

interface SectionHeaderProps {
  icon: ReactNode;
  title: string;
}

export function SectionHeader({ icon, title }: SectionHeaderProps) {
  return (
    <div className="flex items-center gap-3">
      {icon}
      <h3 className="text-lg font-bold leading-7 text-slate-900">{title}</h3>
    </div>
  );
}
